import styles from "./AuthHeader.module.css";

import AuthSearchBar from "./AuthSearchBar.tsx/AuthSearchBar";
import BackButton, { SmallBackButton } from "../buttons/BackButton";

export default function AuthHeader(props: {
  title: string;
  subTitle?: string;
  hideSearch?: boolean;
  inAssessment?: boolean;
  backButton?: boolean;
  step?: boolean;
  onBack?: () => void;
}) {
  return (
    <div
      style={!props.inAssessment ? { borderWidth: "1px" } : {}}
      className={styles.main}
    >
      {props.backButton && (
        <div className={styles.backDiv}>
          <BackButton
            step={props.step}
            onBack={() => props.onBack && props.onBack()}
          />
        </div>
      )}
      <div>
        <h1>{props.title === "@undefined" ? "@username" : props.title}</h1>
        {props.subTitle && (
          <h3 className={styles.subTitle}>{props.subTitle}</h3>
        )}
      </div>

      {!props.hideSearch && (
        <div>
          <AuthSearchBar />
        </div>
      )}
    </div>
  );
}

export function AuthHeaderWithSmallBackButton(props: {
  title: string;
  subTitle?: string;
  hideSearch?: boolean;
  backButton?: boolean;
  onBack?: () => void;
  sticky?: boolean;
}) {
  return (
    <div
      style={{
        position: props.sticky ? "sticky" : "relative",
        top: 0,
        backgroundColor: "#181716",
        zIndex: 5,
      }}
      className={styles.main}
    >
      {props.backButton && (
        <div className={styles.backDiv}>
          <SmallBackButton onClick={() => props.onBack && props.onBack()} />
        </div>
      )}
      <div>
        <h1>{props.title === "@undefined" ? "@username" : props.title}</h1>
        {props.subTitle && (
          <h3 className={styles.subTitle}>{props.subTitle}</h3>
        )}
      </div>
    </div>
  );
}
